import { useEffect, useState } from "react";

import Nav from "react-bootstrap/Nav";

import { useLayout } from "@/../_metronic/layout/core";
import { useCurrentAccount } from "@/hooks/useCurrentAccount";

import { AcsVisitsControl } from "./AcsVisitsControl";
import { CitizenAssistance } from "./CitizenAssistance";

export function ReterritorializationAcsDashboard() {
	const { uf, ibgeCode, cnes } = useCurrentAccount();
	const { setTitle } = useLayout();

	const [optionMenu, setOptionMenu] = useState(1);

	function renderPanel() {
		switch (optionMenu) {
			case 1:
				return <CitizenAssistance uf={uf} ibgeCode={ibgeCode} cnes={cnes} />;
			case 2:
				return <AcsVisitsControl uf={uf} ibgeCode={ibgeCode} cnes={cnes} />;
		}
	}

	useEffect(() => {
		setTitle("GESTÃO DE CADASTRO E VISITAS DOS ACS");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<div style={{ minWidth: "320px" }}>
			<section>
				<div className="d-flex align-items-stretch w-full mx-3 p-0 h-60px h-lg-70px overflow-auto mb-lg-0">
					<Nav
						fill
						variant="tabs"
						defaultActiveKey="/componente-vinculo/"
						className="nav nav-stretch flex-nowrap w-100 h-100"
					>
						<Nav.Item onClick={() => setOptionMenu(1)}>
							<Nav.Link
								eventKey="/componente-vinculo/"
								className="nav-item flex-equal cursor-pointer"
							>
								<div className="d-flex flex-column text-nowrap flex-center w-100">
									<span className="text-uppercase text-gray-900 fw-bolder fs-6 fs-lg-5">
										Monitoramento
									</span>
									<span className="text-gray-500 fs-8 fs-lg-7">Cadastros</span>
								</div>
							</Nav.Link>
						</Nav.Item>
						<Nav.Item onClick={() => setOptionMenu(2)}>
							<Nav.Link
								eventKey="link-2"
								className="nav-item flex-equal cursor-pointer"
							>
								<div className="d-flex flex-column text-nowrap flex-center w-100">
									<span className="text-uppercase text-gray-900 fw-bolder fs-6 fs-lg-5">
										Controle
									</span>
									<span className="text-gray-500 fs-8 fs-lg-7">
										Visitas dos ACS
									</span>
								</div>
							</Nav.Link>
						</Nav.Item>
					</Nav>
				</div>
			</section>
			{renderPanel()}
		</div>
	);
}
